<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goto('/general-step1')"></span></div>

        <div class="daojia-navbar-left" v-show="$route.query.back" @click="$router.go(-1)"><span class="icon-chevron-left"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="image-box">
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_02.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_03.png'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_04.png' @click="$router.push('/service/clean-price?service=dasaochu');">
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_05.png'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_06.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_07.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_08.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_09.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_10.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_11.jpg'>
        <img v-if="order.data.sub_type=='1550735948'" src='/static/img/cleanEx/dasaochu_12.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_02.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_03.png'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_04.png' @click="$router.push('/clean-pricing');">
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_05.png'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_06.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_07.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_08.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_09.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_10.jpg'>
        <img v-if="order.data.sub_type=='1550735960'" src='/static/img/cleanEx/tuifang_11.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_02.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_03.png' @click="$router.push('/service/clean-price?service=duanzuwu');">
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_04.png'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_05.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_06.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_07.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_08.jpg'>
        <img v-if="order.data.sub_type=='1550735961'" src='/static/img/cleanEx/duanzu_09.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_02.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_03.png'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_04.png' @click="$router.push('/service/clean-price?service=zhuanxiang');">
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_05.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_06.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_07.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_08.png' @click="$router.push('/service/clean-price?service=zhuanxiang');">
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_09.jpg'>
        <img v-if="order.data.sub_type=='1550735962'" src='/static/img/cleanEx/zhuanxiang_10.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_02.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_03.png'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_04.png' @click="$router.push('/service/clean-price?service=zhouqi');">
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_05.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_06.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_07.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_08.jpg'>
        <img v-if="order.data.sub_type=='1550735971'" src='/static/img/cleanEx/zhouqi_09.jpg'>
    </div>
    <div class="btn-box-fix" >
      <div class="slogan">点击查看
        <span class="color-orange">
          <span v-if="order.data.sub_type=='1550735948'" @click="$router.push('/service/clean-price?service=dasaochu');">大扫除清洁报价单</span>
          <span v-if="order.data.sub_type=='1550735960'" @click="$router.push('/clean-pricing')">退房 / 开荒清洁报价单</span>
          <span v-if="order.data.sub_type=='1550735961'" @click="$router.push('/service/clean-price?service=duanzuwu');">短租屋清洁报价单</span>
          <span v-if="order.data.sub_type=='1550735962'" @click="$router.push('/service/clean-price?service=zhuanxiang');">专项清洁报价单</span>
          <span v-if="order.data.sub_type=='1550735971'" @click="$router.push('/service/clean-price?service=zhouqi');">周期清洁报价单</span>
        </span>
      </div>
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="goto('/general-step3') ">开始下单</a>
      </div>
    </div>

    <img :src="pixelURL('qingjie','baojia')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'work',
  data () {
    return {
      order:{}
    }
  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
        let localParsed = JSON.parse(localStorage.order);
        this.order = localParsed;
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:50px;
}

.title{
  font-size:1.4em;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.btn-box-fix .btn.active{
  margin-left:0;
}

</style>



// WEBPACK FOOTER //
// src/pages/general/step2.vue